<template>
    <div>
        <div class="popup-active" v-if="showInside">
            <div class="popup-form" v-click-outside="closeEvent">
                <header class="popup-title">
                    <h2>Spara i matdagboken</h2>
                    <svg @click="hide" class="icon popup-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </header>
                <form id="add-to-food-diary" method="POST" v-on:submit.prevent="submitForm" v-if="!prompt">
                    <div class="form-group">
                        <label> Titel </label>
                        <input
                            type="text"
                            name="Namn"
                            v-model="propTitle"
                            class="form-control"
                            v-bind:class="{ 'is-invalid': attemptSubmit && missingTitle }"
                        />
                        <div class="invalid-feedback">Detta fält är obligatoriskt.</div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 meal-type form-group">
                            <label>Måltidstyp</label>
                            <select v-model="meal" class="input-select">
                                <option value="1">Frukost</option>
                                <option value="3">Lunch</option>
                                <option value="5">Middag</option>
                                <option value="8">Mellanmål</option>
                                <option value="0">Snacks / Övrigt</option>
                            </select>
                            <input type="hidden" name="Typ" :value="meal" class="form-control" />
                        </div>
                        <div class="col-xs-12 col-sm-6 form-group">
                            <label>Välj tid och datum</label>
                            <input
                                type="datetime-local"
                                class="form-control"
                                v-if="state.isMobile"
                                v-model="dateTimeNative"
                            />

                            <date-picker
                                v-if="!state.isMobile"
                                v-model="dateTime"
                                type="datetime"
                                format="D MMMM YYYY HH:mm"
                                :clearable="false"
                                :lang="lang"
                                :class="{ 'is-invalid': attemptSubmit && missingDate }"
                                :append-to-body="false"
                                :show-time-panel="showTimePanel"
                                @change="onChangeDatePicker"
                                @open="onOpenDatepicker"
                                @close="onCloseDatepicker"
                            >
                                <div slot="footer" class="actions-date">
                                    <button class="mx-btn mx-btn-text" @click="toggleTimeRangePanel">
                                        <calendar v-if="showTimePanel" />
                                        <timer v-if="!showTimePanel" />
                                    </button>
                                    <button class="mx-btn mx-btn-text" @click="empty">
                                        <trash />
                                    </button>
                                </div>
                            </date-picker>

                            <div class="invalid-feedback">Välj datum och tid</div>

                            <input type="hidden" name="datum" :value="formattedDateTime" />
                            <input type="hidden" name="timme" :value="formattedHour" />
                            <input type="hidden" name="minuter" :value="formattedMinute" />
                            <input type="hidden" name="ReceptID" :value="recipeId" class="form-control" />
                            <input
                                type="hidden"
                                name="kopiera_till_matdagboken"
                                value="ja"
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Portioner</label>
                        <div class="servings-wrapper">
                            <select v-model.number="servings" class="input-select">
                                <option v-for="amount in presetServings" :key="amount" :value="amount">
                                    {{ amount }}
                                </option>
                                <option value="">Egen portionsstorlek</option>
                            </select>
                            <input
                                v-if="servings === ''"
                                v-model.number="rawServings"
                                type="number"
                                min="0.1"
                                step="0.1"
                                class="form-control custom-servings-input"
                                placeholder="Ange portioner..."
                            />
                            <input type="hidden" name="servings" :value="servings || rawServings" class="form-control" />
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Kommentar</label>
                        <textarea name="Kommentar" v-model="comment" class="form-control"></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary">Spara i matdagboken</button>
                </form>
                <span v-if="prompt">{{ prompt }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

import state from "../state.js";

import moment from "moment";

import "moment/min/locales";

import DatePicker from "vue2-datepicker";

import "vue2-datepicker/locale/sv";

import Calendar from "./../icons/Calendar";

import Timer from "./../icons/Timer";

import Trash from "./../icons/Trash";

export default {
	components: {
		DatePicker,
		Calendar,
		Timer,
		Trash,
	},

	props: ["recipeId", "title"],

	mounted() {
		this.propTitle = this.title;
		this.dateTime = new Date();
	},

	data() {
		return {
			state,
			showInside: false,
			dateTime: null,
			dateTimeNative: moment().format("YYYY-MM-DDTHH:mm"),
			meal: 1,
			comment: "",
			baseUrl: window.appConfig.public_url,
			prompt: false,
			attemptSubmit: false,
			currentEvent: null,

			showTimePanel: false,
			showTimeRangePanel: false,
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
				monthBeforeYear: false,
			},

			propTitle: "",

			// Servings
			servings: 1,
			rawServings: 1,
			presetServings: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
		};
	},

	directives: {
		"click-outside": {
			priority: 700,

			bind: function (el, binding, vnode) {
				let self = vnode.context;

				if (!self) {
					console.error("Could not find component context in click-outside directive");
					return;
				}

				self.currentEvent = function (event) {
					self.closeEvent(event);
				};

				// Store on element for unbind access
				el._clickOutsideEvent = self.currentEvent;

				el.addEventListener("click", (event) => event.stopPropagation());

				document.body.addEventListener("click", self.currentEvent);

				$("body").addClass("lock");
			},

			unbind: function (el) {
				el.removeEventListener("click", (event) => event.stopPropagation());

				document.body.removeEventListener("click", el._clickOutsideEvent);

				$("body").removeClass("lock");
			},
		},
	},

	computed: {
		foodDiaryForm: function () {
			return this.state.foodDiaryForm;
		},

		promptSuccess: function () {
			return "Receptet har lagts till i din matdagbok " + this.formattedDateTime + ".";
		},

		promptError: function () {
			return "Något gick fel! Försök igen.";
		},

		missingTitle: function () {
			return this.title === "";
		},

		missingDate: function () {
			return this.formattedDateTime == "[null]";
		},

		validateFields: function () {
			return !this.missingTitle && !this.missingDate;
		},

		formattedDateTime: function () {
			if (this.dateTime === null) return "[null]";

			return moment(this.dateTime).format("YYYY-MM-DD HH:mm");
		},

		formattedHour: function () {
			if (this.dateTime === null) return "[null]";

			return moment(this.dateTime).format("HH");
		},

		formattedMinute: function () {
			if (this.dateTime === null) return "[null]";

			return moment(this.dateTime).format("mm");
		},
	},

	watch: {
		"state.foodDiaryForm.active": function (newVal) {
			if (newVal) this.show();
		},

		dateTimeNative: function (newVal) {
			this.dateTime = moment(newVal);
		},
	},

	methods: {
		onChangeDatePicker: function (dateString) {
			this.dateTime = dateString;
		},

		onOpenDatepicker: function () {
			this.$nextTick(() => {
				document
					.querySelector(".mx-datepicker-popup")
					.addEventListener("click", (e) => e.stopPropagation());
			});
		},

		onCloseDatepicker: function () {
			this.showTimePanel = false;
		},

		toggleTimeRangePanel: function (e) {
			e.preventDefault();
			this.showTimePanel = !this.showTimePanel;
		},

		empty: function () {
			this.dateTime = null;
		},

		show() {
			this.showInside = true;
		},

		hide() {
			this.showInside = false;
			this.state.foodDiaryForm.active = false;
		},

		submitForm(e) {
			this.attemptSubmit = true;

			if (!this.validateFields) return;

			const serialized = $("#add-to-food-diary").serialize();

			const params = new URLSearchParams(serialized);

			let data = {};

			params.forEach((value, key) => {
				data[key] = value;
			});

			console.log(data);

			const { ReceptID, Namn, Kommentar, datum, Typ } = data;

			// Use custom servings if entered (when servings is ''), otherwise use selected servings
			const finalServings = this.servings === "" ? this.rawServings : this.servings;

			axios
				.post("/api/matdagboken/meal/store-from-recipe", {
					recipe_id: ReceptID,
					name: Namn,
					comment: Kommentar,
					datetime: datum,
					meal_type: Typ,
					servings: finalServings,
				})
				.then((response) => {
					if (response.status == 200) {
						this.prompt = this.promptSuccess;
					}
				})
				.catch((error) => {
					if (error) {
						this.error = this.promptError;
					}
				});
		},

		closeEvent() {
			this.hide();
			this.prompt = false;
			this.attemptSubmit = false;
		},
	},
};
</script>
